import { formatUnits } from "viem";
import { robinhood } from "viem/chains";
import { ELYSIUM, elysium, sameIdentity } from "../../../config/elysium";
import type { MintHistoryItem } from "../api/mint-history";
import { nftLabel } from "./nft-label";

export function historyNftLabel(item: MintHistoryItem, chainId: number, collection: string): string {
  if (item.tierUsd === null) return "Tier —";
  let artworkKind: "task" | "referral" | "paid" | null = null;
  // Elysium mint() identifies free social/referral mints by tier and exact fee.
  // Scope this display rule to its collection; tier 100/500 also exist for paid NFTs.
  if (chainId === ELYSIUM.chainId && sameIdentity(collection, ELYSIUM.collection)) {
    if (item.rewardPolicyVersion === "1" && item.mintFeeWei === "0") {
      if (item.tierUsd === 0) artworkKind = "task";
      else if ([50, 100, 500].includes(item.tierUsd)) artworkKind = "referral";
    } else if (["1", "2"].includes(item.rewardPolicyVersion ?? "") &&
      item.mintFeeWei !== null && BigInt(item.mintFeeWei) > 0n &&
      [10, 100, 500, 1000, 2000, 5000].includes(item.tierUsd)) artworkKind = "paid";
  }
  return nftLabel({ tierUsd: item.tierUsd, artworkKind });
}

export function historyFee(wei: string | null, chainId: number | undefined): string {
  if (wei === null) return "—";
  const currency = chainId === elysium.id ? elysium.nativeCurrency : chainId === robinhood.id ? robinhood.nativeCurrency : null;
  return currency ? `${formatUnits(BigInt(wei), currency.decimals)} ${currency.symbol}` : `${wei} wei`;
}
export function historyTime(timestamp: string | null, full = false,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone): string {
  if (timestamp === null) return "Time unavailable";
  const date = new Date(timestamp);
  if (!Number.isFinite(date.getTime())) return "Time unavailable";
  const options = { timeZone, hourCycle: "h23" as const };
  if (full) return `${new Intl.DateTimeFormat("en-GB", { ...options, day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: "shortOffset" }).format(date)} · ${timeZone}`;
  return `${new Intl.DateTimeFormat("en-GB", { ...options, day: "2-digit", month: "short" }).format(date)} · ${
    new Intl.DateTimeFormat("en-GB", { ...options, hour: "2-digit", minute: "2-digit" }).format(date)}`;
}
